import React, { FC } from 'react';

import { glueName } from '@/shared/utils/users';

import { Flex } from 'antd';
import ImgWin from '@/shared/pictures/forecast_win.svg';
import dayjs from '@/shared/lib/dayjs';
import { IBet } from '../types';


interface MembersMeItemProps {
  place: number,
  user:IBet
}

export const MembersMeItem:FC<MembersMeItemProps> = ({place,user}) => {

  return (
    <div className='forecast-members-me_list__item'>
      <p className='forecast-members-me_list__number'>{place}</p>
      <div className='forecast-members-me_list__user'>
        <img className='forecast-members-me_list__icon' src={user.photoUrl} alt="icon" />
        <Flex vertical>
          <p className='forecast-members-me_list__name'>{glueName(user)}</p>
          <p className='forecast-members-me_list__result'>{user.homeScore}:{user.awayScore}, {user.oviGoals}+{user.oviHelps} | {dayjs(user.createdAt).format('HH:mm:ss') }</p>
        </Flex>
       </div>

        {user.isWin&&
        <div className='forecast-members-me_list__win'>
          <img src={ImgWin} alt="icon" />
          <p>Победитель</p>
        </div>}

    </div>
  );

};